export default {
    'Europe (EU) region': [
        {
            value: 'A1RKKUPIHCS9HS',
            text: 'www.amazon.es'
        },
        {
            value: 'A13V1IB3VIYZZH',
            text: 'www.amazon.fr'
        },
        {
            value: 'A1PA6795UKMFR9',
            text: 'www.amazon.de'
        },
        {
            value: 'APJ6JRA9NG5V4',
            text: 'www.amazon.it'
        },
        {
            value: 'A1F83G8C2ARO7P',
            text: 'www.amazon.co.uk'
        },
    ],
    'North America (NA) region': [
        {
            value: 'A2EUQ1WTGCTBG2',
            text: 'www.amazon.ca'
        },
        {
            value: 'ATVPDKIKX0DER',
            text: 'www.amazon.com'
        },
        {
            value: 'A1AM78C64UM0Y8',
            text: 'www.amazon.com.mx'
        }
    ],
    'Brazil (BR) region': [
        {
            value: 'A2Q3Y263D00KWC',
            text: 'www.amazon.com.br'
        }
    ],
    'India (IN) region': [
        {
            value: 'A21TJRUUN4KGV',
            text: 'www.amazon.in'
        }
    ],
    'Australia and Japan (FE) region': [
        {
            value: 'A39IBJ37TRP1C6',
            text: 'www.amazon.com.au'
        },
        {
            value: 'A1VC38T7YXB528',
            text: 'www.amazon.co.jp'
        }
    ],
    'China (CN) region': [
        {
            value: 'AAHKV2X7AFYLW',
            text: 'www.amazon.cn'
        },
    ]
}



// WEBPACK FOOTER //
// ./src/assets/js/region-codes/amazon.js